import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

interface UseCaseCTAProps {
  accentColor: string;
}

const UseCaseCTA = ({ accentColor }: UseCaseCTAProps) => {
  const trustItems = [
    "Installation en 5 min",
    "Support francais",
    "Sans engagement",
  ];

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden bg-[#0A0A0F]">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0F172A] to-[#0A0A0F]" />

      {/* Glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] bg-[#F59E0B]/8 rounded-full blur-[200px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6 animate-fade-up">
            Pret a optimiser
            <span className="block" style={{ color: accentColor }}>
              votre rentabilite ?
            </span>
          </h2>

          {/* Subtitle */}
          <p className="text-lg text-white/50 mb-10 max-w-xl mx-auto animate-fade-up [animation-delay:100ms]">
            Essayez B8ild gratuitement pendant 14 jours et voyez exactement ou vous en etes sur vos chantiers.
          </p>

          {/* CTA */}
          <div className="mb-10 animate-fade-up [animation-delay:200ms]">
            <Button
              size="lg"
              className="h-14 px-8 bg-[#F59E0B] hover:bg-[#FBBF24] text-[#0A0A0F] font-semibold text-lg gap-3 rounded-xl shadow-[0_0_0_1px_rgba(245,158,11,0.3),0_8px_40px_rgba(245,158,11,0.4)] hover:shadow-[0_0_0_1px_rgba(245,158,11,0.5),0_12px_50px_rgba(245,158,11,0.5)] hover:scale-[1.02] transition-all duration-300"
              asChild
            >
              <Link to="/auth?mode=signup">
                Commencer gratuitement
                <ArrowRight className="h-5 w-5" />
              </Link>
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 animate-fade-up [animation-delay:300ms]">
            {trustItems.map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="h-5 w-5 rounded-[4px] bg-[#131318] border border-white/[0.06] flex items-center justify-center">
                  <Check className="h-3 w-3 text-white/50" strokeWidth={2.5} />
                </div>
                <span className="text-sm text-white/50">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseCTA;
